import { Routes, Route, Navigate } from "react-router";
import Login from "./components/Login";
import Nav from "./components/Nav";
import Home from "./components/Home";
import NotesList from "./components/notes/NotesList";
import NoteDetail from "./components/notes/NoteDetail";
import ProtectedRoute from "./routes/ProtectedRoute";

export default function App() {
  return (
    <div className="flex flex-col items-center justify-start h-screen w-screen p-4">
      <Nav />

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/notes" element={<NotesList />} />
            <Route path="/notes/:id" element={<NoteDetail />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}
